import { Link } from 'react-router-dom'

const NotFound = () => {
    return (
        <div className="flex min-h-[70vh] flex-col items-center justify-center px-4 text-center">
            <h1 className="text-4xl font-bold text-emerald-300">404</h1>
            <p className="mt-3 text-lg text-gray-300">The page you requested could not be found.</p>
            <Link
                to="/"
                className="mt-6 rounded-md bg-emerald-500 px-4 py-2 font-medium text-gray-950 hover:bg-emerald-400"
            >
                Back Home
            </Link>
        </div>
    )
}

export default NotFound
